import module from 'module';

class OperationService {
  constructor(http) {
    this.http = http;
  }

  fetchOperationDetails(operationId, options) {
    return this.http.get(`/products/operations/${operationId}`, options);
  }

  async fetchOperations(params) {
    return this.http.get('/products/operations', {
      params: {
        productId: params.productId,
        group: params.group,
        dateFrom: params.dateFrom,
        dateTo: params.dateTo
      }
    }).toPromise();
  }
}

module.service('operationService', OperationService);